import { ifAuthenticated } from '@/router/index';
import WorkEnterpriseShow from '@/views/pages/auth/work/enterprise/Show.vue';
import EnterpriseProductsIndex from '@/views/pages/auth/work/enterprise/products/Index.vue';
import WorkLayout from '@/views/layouts/WorkLayout.vue';
import WorkProductShow from '@/views/pages/auth/work/enterprise/products/Show.vue';
import OutgoingIndex from '@/views/pages/auth/work/enterprise/invoices/Outgoing.vue';
import ShowOutgoing from '@/views/pages/auth/work/enterprise/invoices/Show.vue';
import CustomersIndex from '@/views/pages/auth/work/enterprise/customers/Index.vue';
import ShowCustomer from '@/views/pages/auth/work/enterprise/customers/Show.vue';
const PATH = 'work.enterprise.';
export const ENTERPRISE = PATH + 'show';
export const ENTERPRISE_PRODUCTS = PATH + 'products';
export const ENTERPRISE_PRODUCTS_SHOW = PATH + 'products.show';
export const OUTGOING_INVOICES = PATH + 'invoices.outgoing';
export const OUTGOING_INVOICES_SHOW = PATH + 'outgoing.show';
export const CUSTOMERS = PATH + 'customers';
export const CUSTOMERS_SHOW = PATH + 'customers.show';
export const WORK = 'work';

export default [
  {
    path: '/work/enterprise/:enterprise',
    name: 'work.enterprise',
    component: WorkLayout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: 'products',
        name: ENTERPRISE_PRODUCTS,
        component: EnterpriseProductsIndex,
        children: [{
          path: ':product',
          name: ENTERPRISE_PRODUCTS_SHOW,
          component: WorkProductShow
        }]
      },
      {
        path: 'invoices/outgoing',
        name: OUTGOING_INVOICES,
        component: OutgoingIndex,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'invoices/outgoing/:invoice',
        name: OUTGOING_INVOICES_SHOW,
        component: ShowOutgoing,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'customers',
        name: CUSTOMERS,
        component: CustomersIndex,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'customers/:customer',
        name: CUSTOMERS_SHOW,
        component: ShowCustomer,
        beforeEnter: ifAuthenticated
      },
      {
        path: 'show',
        name: ENTERPRISE,
        component: WorkEnterpriseShow,
        meta: {},
        beforeEnter: ifAuthenticated
      }
    ]
  }
];
